import { useEffect, useState } from "react"
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import { IUserGroup } from "../interfaces/IUser";
import { GetUserGroupByUserID, GetUserGroup } from "../services/userGroup";


export const useListUserGroupByUser = () => {

    // States
    const [listUserGroup, setListUserGroup] = useState<IUserGroup[]>([]);
    const [loadingUserGroup, setLoadingUserGroup] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetUserGroup();
    }, [])

    // Handles
    const handleGetUserGroup = () => {
        setLoadingUserGroup(true)
        tryCatch(() => {
            GetUserGroupByUserID()
                .then((response) => {
                    setListUserGroup(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingUserGroup(false));
        })
    }

    return {
        listUserGroup,
        loadingUserGroup
    }
}

export const useListUserGroup = () => {

    // States
    const [listUserGroupAll, setListUserGroupAll] = useState<IUserGroup[]>([]);
    const [loadingUserGroupAll, setLoadingUserGroupAll] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetUserGroup();
    }, [])

    // Handles
    const handleGetUserGroup = () => {
        setLoadingUserGroupAll(true)
        tryCatch(() => {
            GetUserGroup()
                .then((response) => {
                    setListUserGroupAll(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingUserGroupAll(false));
        })
    }

    return {
        listUserGroupAll,
        loadingUserGroupAll
    }
}